"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductClassificationSelect = void 0;
const product_1 = require("@treez/commons/sharedTypings/product");
const react_1 = __importDefault(require("react"));
const SelectInput_1 = __importDefault(require("./SelectInput"));
const classificationOptions = [
    product_1.Classification.CBD,
    product_1.Classification.HYBRID,
    product_1.Classification.INDICA_SATIVA,
    product_1.Classification.INDICA,
    product_1.Classification.KUSH,
    product_1.Classification.NONE,
    product_1.Classification.SATIVA_INDICA,
    product_1.Classification.SATIVA,
];
exports.ProductClassificationSelect = (props) => (react_1.default.createElement(SelectInput_1.default, Object.assign({ label: 'Classification', options: classificationOptions }, props)));
exports.default = exports.ProductClassificationSelect;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUHJvZHVjdENsYXNzaWZpY2F0aW9uU2VsZWN0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2Zvcm1zL1Byb2R1Y3RDbGFzc2lmaWNhdGlvblNlbGVjdC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsa0VBQWdGO0FBQ2hGLGtEQUVpRDtBQUNqRCxnRUFBeUQ7QUFpQnpELE1BQU0scUJBQXFCLEdBQUc7SUFDMUIsd0JBQWMsQ0FBQyxHQUFHO0lBQ2xCLHdCQUFjLENBQUMsTUFBTTtJQUNyQix3QkFBYyxDQUFDLGFBQWE7SUFDNUIsd0JBQWMsQ0FBQyxNQUFNO0lBQ3JCLHdCQUFjLENBQUMsSUFBSTtJQUNuQix3QkFBYyxDQUFDLElBQUk7SUFDbkIsd0JBQWMsQ0FBQyxhQUFhO0lBQzVCLHdCQUFjLENBQUMsTUFBTTtDQUN4QixDQUFDO0FBRVcsUUFBQSwyQkFBMkIsR0FBRyxDQUFDLEtBQVksRUFBRSxFQUFFLENBQUMsQ0FDekQsOEJBQUMscUJBQVcsa0JBQ1IsS0FBSyxFQUFnQixnQkFBZ0IsRUFDckMsT0FBTyxFQUFjLHFCQUFxQixJQUN0QyxLQUFLLEVBQ1gsQ0FDTCxDQUFDO0FBRUYsa0JBQWUsbUNBQTJCLENBQUMifQ==